import AbstractRequestTask from '../AbstractRequestTask';
import getAppConfig from '../../../config/appConfig';
import settings from '../../../devices/all/settings';
import Utils from '../../../utils/Utils';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

/**
 * Se usar para tracking:
 *  error
 *  tick
 *  success
 */
class AudioTrackerTask extends AbstractRequestTask {
    constructor(
        url,
        params = {},
        showErrorModal = true,
        cm_access_token,
        method = 'GET',
        body = null
    ) {
        super();

        this.config = getAppConfig();
        this.url = url;
        this.params = params;
        this.cm_access_token = cm_access_token;
        this.showErrorModal = showErrorModal;
        this.method = method;
        this.apiVersion = '2.0.0';
        this.body = body;
    }

    getUrl() {
        if (this.getMethod() === 'POST') {
            let url = `${this.url}?`;
            url += Utils.buildQueryParams(this.getGETParams());

            return url;
        } else {
            return this.url;
        }
    }

    getMethod() {
        return this.method;
    }

    getParams() {
        if (this.getMethod() === 'POST') {
            const params = {};
            if (this.url.indexOf('tracking/success') !== -1) {
                params.data = JSON.stringify(this.body.data);
                params.device = JSON.stringify(this.body.device);
            }

            return params;
        } else {
            return this.getGETParams();
        }
    }

    getGETParams() {
        const params = super.getParams(this.config);
        const { tenant_code } = settings;
        params.tenant_code = tenant_code;
        params.version = this.apiVersion;
        params.cm_access_token = this.cm_access_token;

        return { ...params, ...this.params };
    }

    isValid(data) {
        if (!data.response) {
            if (typeof data.success !== 'undefined' && data.success === true) {
                return true;
            } else {
                return false;
            }
        }

        return true;
    }

    getShowModal() {
        return this.showErrorModal;
    }

    success(data, b) {
        this.resolve(data);
    }

    getRetriesNumber() {
        return 0; // caso de tracking para que solo envie una vez la peticion y no tenga reintentos TODO checar que en mis contenidos tambien utiliza este task
    }

    getEncType() {
        if (this.getMethod() === 'POST') {
            return 'application/x-www-form-urlencoded';
        }
        return super.getEncType();
    }

    getHeaders() {
        let headerParams = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
        
        return headerParams;
    }

    parseErrors(err) {
        if (this.showErrorModal) {
            super.parseErrors(err);
        } else {
            return {};
        }
    }


    getShowErrorModal(){
        return ENABLE_MODAL_RETRIES;
    }
}

export default AudioTrackerTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/trackers/AudioTrackerTask.js